import { forwardRef, useEffect, useImperativeHandle } from 'react';
import dynamic from 'next/dynamic';
import useLazy from '@/hooks/useLazy';
import Loading from '@/components/common/Indicator/Loading';

const SortFilterModal = dynamic(() => import('./sort-filter'), { ssr: false, loading: Loading });

type Props = {
  sortArr: Array<any>;
  filterArr: Array<any>;
  sortRadio: string;
  filterCheckBoxArr: Array<any>;
  resetCallback?: () => void;
  onCancel: (e?: any) => void;
  applyCallback: (cacheSort: string, cacheFilterArr: any, filterCount: number) => void;
  wrapperClassName?: string;
  /**
   * 是否预加载(在客户端预加载)
   * 为了提高页面INP，对一些使用几率高的懒加载组件进行预加载
   * 避免用户点击按钮后一段时间内页面无响应
   */
  isPreload?: boolean;
} & ObjectType;

const SortFilter = forwardRef((props: Props, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  const { isPreload } = props;

  useImperativeHandle(ref, () => ({
    show: show
  }));

  useEffect(() => {
    if (isPreload) {
      import('./sort-filter');
    }
  }, [isPreload]);

  if (!loaded) return null;
  return <SortFilterModal {...props} modalShow={visible} onCancel={hide} />;
});

export default SortFilter;
